import { Box,  Heading, Input,Text ,Image} from "@chakra-ui/react";
import "../integrations.css"

export const Integration=()=>{
    return (
      <>
        <br />
        <br />
        <br />
        <br />
        <br />
        <Box className="des">
          <Heading letterSpacing={3} as={"h3"} size="md">
            TRACKING TIME BUTTON FOR CHROME
          </Heading>
          <br />
          <Box className="h1">
            <Heading letterSpacing={3} as={"h1"} size="3xl">
              TrackingTime Integrations
            </Heading>
          </Box>
          <br />
          <Heading letterSpacing={3} as={"h3"} size="md">
            TIME TRACKING INTEGRATIONS THAT YOU'LL LOVE
          </Heading>
          <br />
          <Input width={"57%"} placeHolder="SEARCH YOUR FAVOURITE APP!" />{" "}
          <br />
          <br />
          <Text>
            Improve your time tracking and increase your productivity with these
            Integrations. See how much time you spend on each task or project!
            TrackingTime's integrations make it easy to keep track of your
            billable and non-billable tasks by integrating with more than 30
            apps.
          </Text>
          <br />
          <Text>
            TrackingTime can be integrated with other apps, such as project
            management, accounting, and customer support. Get instant timesheets
            and analytics with TrackingTime!
          </Text>
          <br />
          <br />
        </Box>
        <div className="outer-div">
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/airtable.png"
              />
            </Box>{" "}
            <br />
            <Heading as={"h3"} size={"lg"}>
              Airtable
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Powerful organizational spreadsheets that works exactly the way
              you want.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/anydo.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Any.Do
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Any.Do helps you get things done with your friends in a simple &
              elegant way.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/asana.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Asana
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Asana puts tasks and conversations together to enable teamwork
              without email.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/azendoo.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Azendoo
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Simplifies projects planning, documents sharing and teamwork
              synchronization for both your professional activity and your life.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/podio.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Podio
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Podio lets you build and shape the online workplace most fitting
              to your role.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/azure-devops.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Azure DevOps
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Continuous Delivery Services for teams to share code, track work,
              and ship software.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/basecamp-2.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Basecamp 2
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Basecamp is a web-based project collaboration tool that allows
              groups of people to share files.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/bitbucket.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Bitbucket
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Bitbucket is a code hosting site, for the Git and Mercurial
              version control systems.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/coda-time-tracking.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Coda
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Coda blends the flexibility of a document, the power of a
              spreadsheet.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/dixa-time-tracking.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Dixa
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Customer service platform that unifies phone, email, chat and
              messaging apps.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/evernote-time-tracking.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Evernote
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Create documents, collaborate on projects, and store information
              all in one place.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/favro.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Favro
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Balance power and simplicity in the ideal collaboration app for
              developers.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/assembla-time-tracking.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Assembla
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Online workspaces with best of breed tools like Tasks & Issue
              Management, SVN & Git Repositories.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/figma-time-tracking.png"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Figma
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Cloud-based platform that enables businesses to create custom
              designs.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/flow.svg"
              />
            </Box>
            <br />
            <Heading as={"h3"} size={"lg"}>
              Flow
            </Heading>
            <br />
            <Text color={"#7f8488"}>
              Manage tasks, share files, have discussions, and capture ideas all
              in one place.
            </Text>
          </div>
          <div>
            <Box className="img-box">
              <Image
                className="app-img"
                src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/freshdesk.png"
              />
            </Box><br />
            <Heading as={"h3"} size={"lg"}>
              Freshdesk
            </Heading><br />
            <Text color={"#7f8488"}>
              Freshdesk is an award-winning, online help desk software that
              allows you to support customers.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/github.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              GitHub
            </Heading><br />
            <Text color={"#7f8488"}>
              GitHub is a web-based hosting service for projects that use the
              Git revision control system.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/gitlab.png"
            />
            </Box><br />
            <Heading as={"h3"} size={"lg"}>
              GitLab
            </Heading><br />
            <Text color={"#7f8488"}>
              GitLab is a on-premise or hosted Git repository management tool.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/ring-central-time-tracking.png"
            />
            </Box><br />
            <Heading as={"h3"} size={"lg"}>
              Ring Central
            </Heading><br />
            <Text color={"#7f8488"}>
              Conversation platform for teams to plan, share & organize work
              tasks.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/gmail.png"
            />
            </Box><br />
            <Heading as={"h3"} size={"lg"}>
              Gmail
            </Heading><br />
            <Text color={"#7f8488"}>
              Gmail is a free search-based web-mail service by Google.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/slack.png"
            />
            </Box><br />
            <Heading as={"h3"} size={"lg"}>
              Slack
            </Heading><br />
            <Text color={"#7f8488"}>
              Slack brings all your communication together in one place.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/google-calendar.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              Google Calendar
            </Heading><br />
            <Text color={"#7f8488"}>
              With Google Calendar, its easy to keep track of all your lifes
              important events in one place.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/gdocs.png"
            />
            </Box><br />
            <Heading as={"h3"} size={"lg"}>
              Google Docs
            </Heading><br />
            <Text color={"#7f8488"}>
              Google Docs is an online word processor, part of Google Drive.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/temp/logos/gsheets.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              Google Sheets
            </Heading><br />
            <Text color={"#7f8488"}>
              Google Sheets is an online spreadsheet app that lets you create
              and format spreadsheets.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/google-drive.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              Google Slides
            </Heading><br />
            <Text color={"#7f8488"}></Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/google-drive.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              Google Slides
            </Heading><br />
            <Text color={"#7f8488"}>
              Google Slides is a presentation app offered by Google.
            </Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/teamwork-time-tracking.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              Teamwork
            </Heading><br />
            <Text color={"#7f8488"}>Teamwork</Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/google-chat.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              Google Chat
            </Heading><br />
            <Text color={"#7f8488"}>Collaborate on Google chat</Text>
          </div>
          <div>
            <Box className="img-box">
            <Image
              className="app-img"
              src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/button/microsoft-to-do.png"
            /></Box><br />
            <Heading as={"h3"} size={"lg"}>
              Microsoft To Do
            </Heading><br />
            <Text color={"#7f8488"}>
              Microsoft To Do is a task management app to help you stay
              organized and manage your day-to-day.
            </Text>
          </div>
        </div>
      </>
    );
}